(() => {
  const selector = '[data-wella-review-page]';

  const initialize = (scope) => {
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);

    roots.forEach((root) => {
      if (root.dataset.reviewFiltersReady === 'true') return;

      const controls = root.querySelector('[data-review-controls]');
      const cards = [...root.querySelectorAll('[data-review-card]')];
      const result = root.querySelector('[data-review-result]');
      const empty = root.querySelector('[data-review-filter-empty]');
      const stars = root.querySelector('[data-review-rating-filter]');
      const buttons = [...root.querySelectorAll('[data-review-filter]')];
      if (!controls || !cards.length || !result || !empty || !stars) return;

      root.dataset.reviewFiltersReady = 'true';
      let category = 'all';
      const update = () => {
        let visible = 0;
        cards.forEach((card) => {
          const categoryMatches = category === 'all' || card.dataset.reviewCategory === category;
          const ratingMatches = stars.value === 'all' || Number(card.dataset.reviewRating) === Number(stars.value);
          card.hidden = !(categoryMatches && ratingMatches);
          if (!card.hidden) visible += 1;
        });
        result.textContent = root.dataset.resultTemplate.replace('[count]', String(visible));
        empty.hidden = visible !== 0;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          category = button.dataset.reviewFilter;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          update();
        });
      });
      stars.addEventListener('change', update);
      controls.hidden = false;
      update();
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
